import { NgModule, Component } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ExcelUploadComponent } from "./components/admin/excel-upload/excel-upload.component";
import { AuthComponent } from "./components/auth/auth.component";
import { SignUpComponent } from "./components/auth/sign-up/sign-up.component";
import { CostingPageComponent } from "./components/costing-page/costing-page.component";
import { CostingPageNewComponent } from "./components/costing-page-new/costing-page-new.component";
import { DatadirectoryComponent } from "./components/data-directory/datadirectory.component";
import { HomeComponent } from "./components/home/home.component";
import { ReportsComponent } from "./components/reports/reports.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { UploadFilesComponent } from "./components/upload-files/upload-files.component";
import { UserFormComponent } from "./components/user-form/user-form.component";
import { EstCalculationComponent } from "./components/est-calculation/est-calculation.component";
import { ErrorListComponent } from "./components/error-list/error-list.component";
import { CommercialIntelligenceComponent } from "./components/commercial-intelligence/commercial-intelligence.component";
import { SalesVolumeComponent } from "./components/sales-volume/sales-volume.component";
import { Router } from "@angular/router";
import { FileuploadComponent } from "./components/fileupload/fileupload.component";
import { FilessalesandvolumeComponent } from "./components/filessalesandvolume/filessalesandvolume.component";
import { UserregisterComponent } from "./components/userregister/userregister.component";
import { LifecycleintellegenceComponent } from "./components/lifecycleintellegence/lifecycleintellegence.component";
import { ScrapingupdateComponent } from "./components/scrapingupdate/scrapingupdate.component";
import { LogmanagementComponent } from "./components/logmanagement/logmanagement.component";
import { BusinesscaseComponent } from './components/businesscase/businesscase.component';
import { ErrorDashboardComponent } from './components/error-dashboard/error-dashboard.component';
import { IrrComponent } from './components/error-dashboard/irr/irr.component';
import { IrrNpvComponent } from './components/error-dashboard/irr-npv/irr-npv.component';
import { NewsalesandvolumeComponent } from './components/error-dashboard/newsalesandvolume/newsalesandvolume.component';
import { AnticipatedDateComponent } from './components/error-dashboard/anticipated-date/anticipated-date.component';
import { NewcostingComponent } from './components/error-dashboard/newcosting/newcosting.component';
import { CostingcheckerComponent } from './components/error-dashboard/costingchecker/costingchecker.component';
import { UploadtoliveComponent } from './components/uploadtolive/uploadtolive.component';
import { UserRegistrationComponent } from './components/user-registration/user-registration.component';
import { RequestTrainingComponent } from './components/request-training/request-training.component';
import { ProductDashboardComponent } from './components/product-dashboard/product-dashboard.component';
import { AllRldComponent } from "./components/error-dashboard/all-rld/all-rld.component";
import { ExcelManagerComponent } from "./components/excel-manager/excel-manager.component"
import { LitigationDashboardComponent } from "./components/litigation-dashboard/litigation-dashboard.component";
import { NewCostingComponent } from "./components/new-costing/new-costing.component";
import { NewApiCostingComponent } from "./components/new-costing/new-api-costing/new-api-costing.component";
import { RightsWiseLoginComponent } from "./components/rights-wise-login/rights-wise-login.component";
import { LitigationComplaintsComponent } from "./components/litigation-complaints/litigation-complaints.component";
import { SubscriberEmailComponent } from "./components/subscriber-email/subscriber-email.component";
import { SubscriberMailUsersComponent } from "./components/subscriber-mail-users/subscriber-mail-users.component";
import { NewSubscriberMailComponent } from "./components/new-subscriber-mail/new-subscriber-mail.component";
import { FieldReviewDashboardComponent } from "./components/field-review-dashboard/field-review-dashboard.component";
import { ViewAllLitigationComplaintsComponent } from "./components/view-all-litigation-complaints/view-all-litigation-complaints.component";
import { UserOwnSettingComponent } from "./components/user-own-setting/user-own-setting.component";
import { SaleVolumeCompareComponent } from "./sale-volume-compare/sale-volume-compare.component";
import { GetMostSearchedComponent } from "./get-most-searched/get-most-searched.component";
import { CompanyMasterComponent } from "./components/company-master/company-master.component";
import { ProductStatusDashboardComponent } from "./components/product-status-dashboard/product-status-dashboard.component";
import { BusinesscaseStatusDashboardComponent } from "./components/businesscase-status-dashboard/businesscase-status-dashboard.component";
import { PatentExpirationComponent } from "./components/error-dashboard/patent-expiration/patent-expiration.component";
import { ExcelDumpDashboardComponent } from "./components/excel-dump-dashboard/excel-dump-dashboard.component";
import { PadufaComponent } from "./components/padufa/padufa.component";
import { PeakSaleComponent } from "./components/peak-sale/peak-sale.component";
import { ImportantUpdatesComponent } from "./components/important-updates/important-updates.component";
import { LitigationEventsComponent } from "./components/error-dashboard/litigation-events/litigation-events.component";
import { AppealEventsComponent } from "./components/error-dashboard/appeal-events/appeal-events.component";
import { SectionWiseEmailComponent } from "./components/section-wise-email/section-wise-email.component";
import { LmsDsManualEntryComponent } from "./components/lms-ds-manual-entry/lms-ds-manual-entry.component";
import { PushToLiveComponent } from "./components/push-to-live/push-to-live.component";
import { PteEventsComponent } from "./components/pte-events/pte-events.component";
import { ShortagePanelComponent } from "./components/shortage-panel/shortage-panel.component";
import { UploadShortageFileComponent } from "./components/upload-shortage-file/upload-shortage-file.component";

const routes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: AuthComponent },
  // { path: "signup", component: SignUpComponent },
  { path: "home", component: HomeComponent },
  { path: "costing", component: CostingPageComponent },
  { path: "datadirectory", component: DatadirectoryComponent },
  { path: "est_api", component: CostingPageNewComponent },
  { path: "est_rld", component: EstCalculationComponent },
  // { path: "check_case_of_api", component: ErrorListComponent },
  // { path: "excelupload", component: ExcelUploadComponent },
  { path: "settings", component: SettingsComponent },
  { path: "user-own-setting", component: UserOwnSettingComponent },
  { path: "sale-volume-compare", component: SaleVolumeCompareComponent },

  // { path: "userform", component: UserFormComponent },
  { path: "uploadfiles", component: UploadFilesComponent },
  // { path: "reports", component: ReportsComponent },
  // { path: "fileupload", component: FileuploadComponent },
  // { path: "userregister", component: UserregisterComponent },
  { path: "filessalesandvolume", component: FilessalesandvolumeComponent },
  {
    path: "commercial_intelligence",
    component: CommercialIntelligenceComponent,
  },
  { path: "sales_volume", component: SalesVolumeComponent },
  // {
  //   path: "lifecycleintellegence",
  //   component: LifecycleintellegenceComponent,
  // },
  {
    path: "scrapingupdate",
    component: ScrapingupdateComponent,
  },
  {
    path: "logmanagement",
    component: LogmanagementComponent,
  },
  {
    path: "businesscase",
    component: BusinesscaseComponent,
  },
  {
    path: "errordashboard",
    component: ErrorDashboardComponent,
  },
  {
    path: "irr",
    component: IrrComponent,
  },
  {
    path: "irr-npv",
    component: IrrNpvComponent,
  },
  {
    path: "newsalesandvolume",
    component: NewsalesandvolumeComponent,
  },
  {
    path: "anticipated-date",
    component: AnticipatedDateComponent,
  },
  {
    path: "newcosting",
    component: NewcostingComponent,
  },
  {
    path: "costingchecker",
    component: CostingcheckerComponent,
  },
  {
    path: "uploadtolive",
    component: UploadtoliveComponent,
  },
  {
    path: "user-registration",
    component: UserRegistrationComponent,
  },
  {
    path: "company-master",
    component: CompanyMasterComponent,
  },
  {
    path: "request-training",
    component: RequestTrainingComponent,
  },
  {
    path: "product-dashboard",
    component: ProductDashboardComponent,
  },
  {
    path: "all-rld",
    component: AllRldComponent,
  },
  {
    path: "excel-manager",
    component: ExcelManagerComponent,
  },
  {
    path: "litigation-dashboard",
    component: LitigationDashboardComponent,
  },
  {
    path: "litigation-complaints",
    component: LitigationComplaintsComponent,
  },
  {
    path: "view-all-litigation-complaints",
    component: ViewAllLitigationComplaintsComponent,
  },
  {
    path: "company-master",
    component: CompanyMasterComponent,
  },
  {
    path: "get-most-searched",
    component: GetMostSearchedComponent,
  },
  {
    path: "new-costing",
    component: NewCostingComponent,
  },
  {
    path: "register-user",
    component: RightsWiseLoginComponent,
  },
  // {
  //   path: "subscriber-email",
  //   component: SubscriberEmailComponent,
  // },
  {
    path: "subscriber-mail-users",
    component: SubscriberMailUsersComponent,
  },
  {
    path: "new-subscriber-email",
    component: NewSubscriberMailComponent,
  },
  {
    path: "field-review-dashboard",
    component: FieldReviewDashboardComponent,
  },
  {
    path: "product-status-dashboard",
    component: ProductStatusDashboardComponent,
  },
  {
    path: "businesscase-status-dashboard",
    component: BusinesscaseStatusDashboardComponent,
  },
  {
    path: "patents-expiration",
    component: PatentExpirationComponent,
  },
  {
    path: "excel-dump",
    component: ExcelDumpDashboardComponent,
  },
  {
    path: "pdufa",
    component: PadufaComponent,
  },
  {
    path: "peak-sale",
    component: PeakSaleComponent,
  },
  {
    path: "important-updates",
    component: ImportantUpdatesComponent,
  },
  {
    path: "litigation-events",
    component: LitigationEventsComponent,
  },
  {
    path: "appeal-events",
    component: AppealEventsComponent,
  },
  {
    path: "section-wise-email",
    component: SectionWiseEmailComponent,
  },
  {
    path: "lms-ds-manual-entry",
    component: LmsDsManualEntryComponent
  },
  {
    path: "push-to-live",
    component: PushToLiveComponent
  },
  {
    path: "pte-events",
    component: PteEventsComponent
  },
  {
    path: "shortage-panel",
    component: ShortagePanelComponent
  },
  {
    path: "upload-shortage-file",
    component: UploadShortageFileComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],

  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    if (
      localStorage.getItem("email") === undefined ||
      localStorage.getItem("email") === null ||
      localStorage.getItem("email") === ""
    ) {
      this.router.navigateByUrl("/login");
    }
  }
}